import gbErrorStatus from "./src/gb-error-status.vue";
const gbErrorStatusComponent = function(Vue) {
  Vue.component(gbErrorStatus.name, gbErrorStatus);
};
export default gbErrorStatusComponent;
